module.exports = __webpack_public_path__ + "img/multiplier5_normal.4e03b4bb.png";